import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Одна заявка во все компании',
  subtitle: 'Повышает вероятность одобрения',
  lessors: 'РосАгроЛизинг, СТОУН-XXI, Интерлизинг, Альфа-лизинг, Fleet\u00A0Finance, СберЛизинг',
  lessorsWithNoAlfaAndStoneXXI: 'РосАгроЛизинг, Интерлизинг, Fleet\u00A0Finance, СберЛизинг',
} satisfies TMessages
